import React from "react";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import Skeleton from "react-loading-skeleton";
import {
    DataGridPro as DataGrid,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from "@mui/x-data-grid-pro";
import {LinearProgress} from "@material-ui/core";
import {
    BBDisableChildren,
    bbDoesCustomerHaveAccessToModule, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
} from "../../../util/bbHelpers";
import DisableChildrenIfDoesntHaveAccessToSubscriptionLevel
    from "../modals/DisableChildrenIfDoesntHaveAccessToSubscriptionLevel";

// class GridToolbarExport extends React.Component<{}> {
//     render() {
//         return null;
//     }
// }
//
// class GridDensitySelector extends React.Component<{}> {
//     render() {
//         return null;
//     }
// }

// const useStyles = makeStyles({
//     root: {
//         display: 'flex',
//     },
// });

const BBDataTable = (props) => {

    // const {tableData, columnHeaders, title, loading, numSkeletonRows, currentPage = 0, maxRecordsDisplayOverride = false, overrideRowsPerPage = 10} = props;
    const {
        columns,
        rows,
        title=null,
        description = null,
        topRightElement = null,
        totalRows = rows.length,
        showGhostsWhileLoading = true,
        progressValue = 0,
        bufferValue = 0,
        showProgress = true,
        loading = false,
        defaultSortModel= [],
        numSkeletonRows = 5,
        rowsPerPageOptions = [10, 25, 50, 100],
        defaultPageSize = 10,
        enableExport = false,
        onRowSelected = null,
        height= null,
        requiresModule = null,
        requiresBRLevel = null,
        customer = null,
        authUser = null,
        entityId = null,
        disableColumnSelector,
        disableDensitySelector,
        disableColumnMenu,
        disableColumnFilter,
        portfolioView = false,
        subscriptionNameOrId = "BRfB",
        trial = false,
        lite = false,
        pro = false,
        premium = false,
        portfolioStarter = false,
        portfolioTrial = false,
        portfolioPro = false,
        portfolioPremium = false,
        overrideForAdminsStaff = false,
        allowHigherSubscriptions = true,
        isActiveSubscriptionRequiredToUse = true,
        elementDisplayNameForConsoleLogs = "Unspecified BBDataTable",
        // id = null,
    } = props;

    const [sortModel, setSortModel] = React.useState(defaultSortModel);
    const [pageSize, setPageSize] = React.useState(defaultPageSize);

    const skeletonColumns = () => {
        if(numSkeletonRows && numSkeletonRows > 0) {
        //create a new set of columns that will render the cell
            const newColumns = []
            for(const column of columns) {
                // { field: 'email', headerName: 'Email', sortable: true, type: 'string', renderCell: (params) => (params.value), flex : 3},
                const newColumn = column;
                newColumn.renderCell = (params) => (params.value);
                newColumn.key = `${column.field}_skeletonColumn`
                // console.log("Pushing this to newcolumns", newColumn)
                newColumns.push(newColumn);
            }
            return newColumns;
        } else {
            return null
        }
    }

    const createSingleSkeletonRow = (columns, row = 0) => {
        const newRow = {}
        for(const column of columns) {
            // console.log("Created skeleton with tableRectKeyId of", `${tableReactKeyId}_${column.field}_skeletonComponent_${row}`);
            newRow[column.field] = <span key={`${column.field}_skeletonCell_${row}`} style={{width:"100%"}}><Skeleton /></span>
        }
        newRow.id = `idkey_skeletonRow_${row}`
        return newRow;
    }

    const skeletonRows = () => {
        if(numSkeletonRows && numSkeletonRows > 0) {
            const newRows = []

            for(const row in [...Array(numSkeletonRows)]) {
                // { field: 'email', headerName: 'Email', sortable: true, type: 'string', renderCell: (params) => (params.value), flex : 3},
                const newRowTemplate = createSingleSkeletonRow(columns, row);
                // console.log("Pushing this to row template", newRowTemplate)
                newRows.push(newRowTemplate)
            }
            return newRows;
        } else {
            return null
        }
    }

    const makeSkeletonRows = (numToMake) => {
            const newRows = []

            for(const row in [...Array(numToMake)]) {
                // { field: 'email', headerName: 'Email', sortable: true, type: 'string', renderCell: (params) => (params.value), flex : 3},
                const newRowTemplate = createSingleSkeletonRow(columns, row);
                // console.log("Pushing this to row template", newRowTemplate)
                newRows.push(newRowTemplate)
            }
            return newRows;
    }

    const rowsToDisplay = () => {
        if (showGhostsWhileLoading && ((rows.length < totalRows && rows.length < 1) || (progressValue < 100 && rows.length <1)) ) {
            //if there are rows that haven't loaded yet
            return makeSkeletonRows(totalRows);
        } else {
            return rows;
        }
    }
    const columnsToDisplay = () => {
        if (showGhostsWhileLoading && ((rows.length < totalRows && rows.length < 1) || (progressValue < 100 && rows.length <1)) ) {
            //if there are rows that haven't loaded yet
            return skeletonColumns();
        } else {
            return columns;
        }
    }

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>

                <GridToolbarColumnsButton/>
                <GridToolbarFilterButton/>
                <GridToolbarDensitySelector/>
                {enableExport &&
                <GridToolbarExport
                    // printOptions={{disableToolbarButton: true }}
                    csvOptions={{ allColumns: true }}/>
                }
            </GridToolbarContainer>
        );
    }

    // const CustomPagination = () => {
    //     const { state, apiRef } = useGridSlotComponentProps();
    //     const classes = useStyles();
    //
    //     return (
    //         <Pagination
    //             className={classes.root}
    //             color="primary"
    //             count={state.pagination.pageCount}
    //             page={state.pagination.page + 1}
    //             onChange={(event, value) => apiRef.current.setPage(value - 1)}
    //         />
    //     );
    // }


    return (
        <Paper style={{marginBottom: "30px"}} id={"tourTable"} className={"tourTable"}>
            {title && <Toolbar className="table-header">
                <div className="title">
                    <h2 variant="title" className={"arrayTableTitle bb-font-fridge-bold"}>{title}
                        {showProgress &&
                            <LinearProgress
                                value ={progressValue}
                                valueBuffer={bufferValue}
                                variant={"buffer"}
                            />
                        }

                    </h2>
                </div>
                {topRightElement &&
                <div style={{marginLeft: 'auto'}} className={"px-2"}>
                    {topRightElement}
                </div> }
            </Toolbar>}
            {description &&
            <><div className={"m-1 ml-2 mr-2 p-1"}>{description}</div></>
            }
            <div style={{height: height, width: "100%"}}>
                <DisableChildrenIfDoesntHaveAccessToSubscriptionLevel
                    elementDisplayNameForConsoleLogs = {elementDisplayNameForConsoleLogs}
                    isActiveSubscriptionRequiredToUse={isActiveSubscriptionRequiredToUse}
                    subscriptionNameOrId={subscriptionNameOrId}
                    trial={trial}
                    lite={lite}
                    pro={pro}
                    premium={premium}
                    portfolioStarter = {portfolioStarter}
                    portfolioTrial = {portfolioTrial}
                    portfolioPro = {portfolioPro}
                    portfolioPremium = {portfolioPremium}
                    overrideForAdminsStaff={overrideForAdminsStaff}
                    allowHigherSubscriptions={allowHigherSubscriptions}
                >
                    <BBDisableChildren
                        isDisabled={requiresModule && customer
                            ? bbDoesCustomerHaveAccessToModule(customer, requiresModule)
                            : requiresBRLevel && customer
                                ? bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, requiresBRLevel, entityId)
                                : true}
                        moduleRequired = {requiresModule ? requiresModule : null}
                        brLevelRequired= {requiresBRLevel ? requiresBRLevel : null}
                        portfolioView={portfolioView}
                    >
                        <DataGrid
                            columns={loading ? skeletonColumns() : columnsToDisplay()}
                            rows={loading ? skeletonRows() : rowsToDisplay()}
                            pageSize={pageSize}
                            autoHeight = {height ? false : true}
                            // autoPageSize
                            pagination
                            disableSelectionOnClick = {!onRowSelected}
                            onRowSelected={onRowSelected}
                            components={{
                                Toolbar: CustomToolbar,
                                // Pagination: CustomPagination,
                            }}
                            // key={tableReactKeyId}
                            // loading={loading}
                            rowsPerPageOptions={rowsPerPageOptions}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            disableColumnMenu={disableColumnMenu ? disableColumnMenu : true}
                            disableDensitySelector={disableDensitySelector ? disableDensitySelector: null}
                            disableColumnSelector={disableColumnSelector ? disableColumnSelector: null}
                            disableColumnFilter={disableColumnFilter ? disableColumnFilter : null}
                            // icons={<BBIconHumanTarget/>}
                            sortModel={sortModel}
                            onSortModelChange={(model) => setSortModel(model)}
                            // id={id ? id : null}
                        />
                    </BBDisableChildren>
                </DisableChildrenIfDoesntHaveAccessToSubscriptionLevel>
            </div>


        </Paper>
    );
};
BBDataTable.propTypes = {
    rows: PropTypes.array,
    columns: PropTypes.array,
    // title: PropTypes.oneOfType([
    //     PropTypes.string.isRequired,
    //     PropTypes.object.isRequired
    // ]),
    loading: PropTypes.bool,
    numSkeletonRows: PropTypes.number,
    defaultPageSize: PropTypes.number,
    rowsPerPageOptions: PropTypes.array,
    progressValue: PropTypes.number,
    bufferValue: PropTypes.number,
    showProgress: PropTypes.bool,
    tableReactKeyId: PropTypes.number,
    topRightElement: PropTypes.element,
    onRowSelected: PropTypes.func,
    height: PropTypes.string,
    enableExport: PropTypes.bool,
    requiresModule: PropTypes.bool,
    customer: PropTypes.object,
    // height: PropTypes.oneOfType([
    //     PropTypes.string,
    //     PropTypes.number
    // ]),
    // width: PropTypes.oneOfType([
    //     PropTypes.string,
    //     PropTypes.number
    // ]),
};

export default BBDataTable;
